const Empty: React.FC<Props> = ({ children, extraClasses }) => <p className={`empty-text ${extraClasses}`}>{children}</p>;

interface Props {
    extraClasses?: string;
}

export default Empty;
